// extracted by mini-css-extract-plugin
module.exports = {"container":"carousel-module--container--2RFpi","slide":"carousel-module--slide--1ZpD9"};